import { Component, OnInit } from '@angular/core';

@Component({
  template: require('./cercas.component.html')
})
export class CercasComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/rastreamentos/cercas/cercas.component.ts
 **/